<template>
  <v-container>
    <v-tabs
      v-model="tab"
      slider-color="primary"
      color="secondary"
      background-color="transparent"
    >
      <v-tab>{{$t('Users.List.header')}}</v-tab>
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="filteredUsers"
          sort-by="firstName"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field 
                v-model="search" 
                hide-details 
                prepend-inner-icon="search" 
                single-line outlined 
                dense 
                :placeholder="$t('Users.List.searchText')"
                style="max-width: 200px"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-dialog v-model="showEditor" max-width="1000px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('Users.Button.addAdmin')}}</v-btn>
                </template>
                <UserEditor 
                  v-if="showEditor"
                  ref="userEditor"
                  :defaultUser="editedIndex >= 0 ? usersList[editedIndex] : null" 
                  @save="save"
                  @cancel="close"
                  @invalid-form="$store.dispatch('errorMessage', $t('Message.Error.invalidForm'))"
                  admin
                />
              </v-dialog>
            </v-toolbar>
            
          </template>
          <template v-slot:item.avatar="{ item }">
            <v-img height="25px" width="25px" :src="getPicturePath(item.picture) || $store.state.defaultPicture"></v-img>
          </template>
          <template v-slot:item.isActive="{ item }">
            <v-chip :color="item.isActive ? 'success' : 'error'">{{item.isActive ? 'Actif' : 'Inactif'}}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn fab small icon @click="editItem(item)" color="secondary">
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn fab small icon @click="deleteItem(item)" color="secondary">
              <v-icon small>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UserEditor from '@/components/User/UserEditor'
import UserHelpersMixin from '@/mixins/UserHelpersMixin'
import FilesPathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
export default {
  components: { UserEditor },
  mixins: [UserHelpersMixin, FilesPathHelpersMixin],
  data: () => ({
    tab: null,
    showEditor: false,
    editedIndex: -1,
    search: '',
  }),

  computed: {
    ...mapState('user', [
      'usersList'
    ]),
    headers () {
      return [
        { sortable: false, value: 'avatar', width: '50px' },
        { text: this.$t('Users.Form.email'), align: 'left', value: 'email', width: '200px' },
        { text: this.$t('Users.Form.firstname'), value: 'firstName', width: '150px' },
        { text: this.$t('Users.Form.lastname'), value: 'lastName', width: '150px' },
        { text: this.$t('Users.Form.mall'), value: 'mall.name', width: '250px' },
        { sortable: false, value: 'isActive', align: 'right' },
        { sortable: false, value: 'actions', width: '125px' },
      ]
    },
    filteredUsers () {
      return this.usersList.filter(user => {
        return this.isAdmin(user) && 
        (user.email && user.email.match(RegExp(this.search, "i")) || 
        user.firstName && user.firstName.match(RegExp(this.search, "i")) || 
        user.lastName && user.lastName.match(RegExp(this.search, "i")) || 
        user.brand && user.brand.match(RegExp(this.search, "i")))
      })
    },
  },

  watch: {
    showEditor (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    ...mapActions('user', [
      'loadUsers',
      'createUser',
      'updateUser',
      'deleteUser'
    ]),
    async initialize () {
      this.loadUsers()
    },

    editItem (item) {
      this.editedIndex = this.usersList.indexOf(item)
      this.showEditor = true
    },

    async deleteItem (item) {
      confirm(this.$t('Users.Message.delete')) && this.deleteUser(item.id)
    },

    close () {
      this.showEditor = false
      this.$refs.userEditor.resetForm()
      setTimeout(() => {
        this.editedIndex = -1
      }, 300)
    },

    async save (user) {
      if (this.editedIndex > -1) {
        try {
          await this.updateUser(user)
          this.close()
        } catch (error) {
          this.$store.dispatch('errorMessage', this.$t('Message.Error.update'))
        }
      } else {
        try {
          await this.createUser(user)
          this.close()
        } catch (error) {
          error === 'users limit reached' 
          ? this.$store.dispatch('errorMessage', this.$t('Users.Message.limitReached'))
          : this.$store.dispatch('errorMessage', this.$t('Message.Error.create'))
        }
      }
    }
  }
}
</script>